import { useAuth0 } from "@auth0/auth0-react";

export default function AuthCallback() {
    const auth0 = useAuth0();

    if (auth0.isLoading && !auth0.error) {
        return <div>Finishing your login</div>;
    }

    async function logout() {
        await auth0.logout(
            {
                logoutParams: {
                    returnTo: window.location.origin,
                },
            }
        );
    }

    if (auth0.error) {
        return (
            <div>
                <p>{ auth0.error.message }</p>
                <button onClick={ logout }>logout</button>
            </div>
        );
    }

    return (
        <div>
            <p>something went wrong</p>
            <button onClick={ logout }>logout</button>
        </div>
    );
}
